"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactSdk = require("@100mslive/react-sdk");
var _reactUi = require("@100mslive/react-ui");
var _reactIcons = require("@100mslive/react-icons");
var _AudioVideoToggle = require("../AudioVideoToggle");
var _SettingsModal = _interopRequireDefault(require("../Settings/SettingsModal"));
var _TileConnection = _interopRequireDefault(require("../Connection/TileConnection"));
var _PreviewName = _interopRequireDefault(require("./PreviewName"));
var _IconButton = _interopRequireDefault(require("../../IconButton"));
var _VirtualBackground = require("../../plugins/VirtualBackground/VirtualBackground");
var _useUserPreferences3 = require("../hooks/useUserPreferences");
var _useUISettings = require("../AppData/useUISettings");
var _constants = require("../../common/constants");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var PreviewJoin = function PreviewJoin(_ref) {
  var token = _ref.token,
    onJoin = _ref.onJoin,
    env = _ref.env,
    skipPreview = _ref.skipPreview,
    initialName = _ref.initialName;
  var _useParams = (0, _reactRouterDom.useParams)(),
    sessionId = _useParams.sessionId;
  var navigate = (0, _reactRouterDom.useNavigate)();
  var _useUserPreferences = (0, _useUserPreferences3.useUserPreferences)(_useUserPreferences3.UserPreferencesKeys.PREVIEW, _useUserPreferences3.defaultPreviewPreference),
    _useUserPreferences2 = _slicedToArray(_useUserPreferences, 2),
    previewPreference = _useUserPreferences2[0],
    setPreviewPreference = _useUserPreferences2[1];
  var _useState = (0, _react.useState)(initialName || previewPreference.name),
    _useState2 = _slicedToArray(_useState, 2),
    name = _useState2[0],
    setName = _useState2[1];
  var _useAVToggle = (0, _reactSdk.useAVToggle)(),
    isLocalAudioEnabled = _useAVToggle.isLocalAudioEnabled,
    isLocalVideoEnabled = _useAVToggle.isLocalVideoEnabled;
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    previewError = _useState4[0],
    setPreviewError = _useState4[1];
  var _usePreviewJoin = (0, _reactSdk.usePreviewJoin)({
      name: name,
      token: token,
      initEndpoint: env ? "https://".concat(env, "-init.100ms.live/init") : undefined,
      initialSettings: {
        isAudioMuted: skipPreview || previewPreference.isAudioMuted,
        isVideoMuted: skipPreview || previewPreference.isVideoMuted
      },
      captureNetworkQualityInPreview: true,
      handleError: function handleError(error, method) {
        if (method === "preview") {
          setPreviewError(true);
          if (error.name === 'InvalidTokenFormat') {
            alert("Invalid meeting URL. \n\nYou're trying to join a meeting that does not exist. If you think this is an error on our side, please reach out to AstroG support");
            navigate("/consultation/".concat(sessionId));
          }
        }
      }
    }),
    enableJoin = _usePreviewJoin.enableJoin,
    preview = _usePreviewJoin.preview,
    join = _usePreviewJoin.join;
  var savePreferenceAndJoin = (0, _react.useCallback)(function () {
    setPreviewPreference({
      name: name,
      isAudioMuted: !isLocalAudioEnabled,
      isVideoMuted: !isLocalVideoEnabled
    });
    join();
    onJoin && onJoin();
  }, [join, isLocalAudioEnabled, isLocalVideoEnabled, name, setPreviewPreference, onJoin]);
  (0, _react.useEffect)(function () {
    if (token) {
      if (skipPreview) {
        savePreferenceAndJoin();
      } else {
        preview();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, skipPreview]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      variant: "h4",
      css: {
        wordBreak: "break-word",
        textAlign: "center"
      },
      children: "Get Started"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
      css: {
        c: "$textMedEmp",
        my: "$6",
        textAlign: "center"
      },
      variant: "body1",
      children: "Setup your audio and video before joining"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      align: "center",
      justify: "center",
      css: {
        "@sm": {
          width: "100%"
        },
        flexDirection: "column"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(PreviewTile, {
        name: name,
        error: previewError
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PreviewControls, {
        enableJoin: enableJoin,
        savePreferenceAndJoin: savePreferenceAndJoin
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PreviewName["default"], {
        name: name,
        onChange: setName,
        enableJoin: enableJoin,
        onJoin: savePreferenceAndJoin
      })]
    })]
  });
};
var Container = (0, _reactUi.styled)("div", _objectSpread(_objectSpread({
  width: "100%"
}, _reactUi.flexCenter), {}, {
  flexDirection: "column",
  px: "$10"
}));
var PreviewTile = function PreviewTile(_ref2) {
  var name = _ref2.name,
    error = _ref2.error;
  var localPeer = (0, _reactSdk.useHMSStore)(_reactSdk.selectLocalPeer);
  var borderAudioRef = (0, _reactUi.useBorderAudioLevel)(localPeer === null || localPeer === void 0 ? void 0 : localPeer.audioTrack);
  var isVideoOn = (0, _reactSdk.useHMSStore)(_reactSdk.selectIsLocalVideoEnabled);
  var mirrorLocalVideo = (0, _useUISettings.useUISettings)(_constants.UI_SETTINGS.mirrorLocalVideo);
  var trackSelector = (0, _reactSdk.selectVideoTrackByID)(localPeer === null || localPeer === void 0 ? void 0 : localPeer.videoTrack);
  var track = (0, _reactSdk.useHMSStore)(trackSelector);
  var _useTheme = (0, _reactUi.useTheme)(),
    _useTheme$aspectRatio = _useTheme.aspectRatio,
    width = _useTheme$aspectRatio.width,
    height = _useTheme$aspectRatio.height;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.StyledVideoTile.Container, {
    css: {
      bg: "$surfaceDefault",
      aspectRatio: width / height,
      width: "unset",
      height: "min(360px, 60vh)",
      mt: "$12",
      "@sm": {
        height: "unset",
        width: "min(360px, 100%)",
        maxWidth: "100%"
      }
    },
    ref: borderAudioRef,
    children: localPeer ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_TileConnection["default"], {
        name: name,
        peerId: localPeer.id,
        hideLabel: true
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Video, {
        mirror: (track === null || track === void 0 ? void 0 : track.facingMode) !== "environment" && mirrorLocalVideo,
        trackId: localPeer.videoTrack,
        "data-testid": "preview_tile"
      }), !isVideoOn ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.StyledVideoTile.AvatarContainer, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Avatar, {
          name: name,
          "data-testid": "preview_avatar_tile"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Text, {
          css: _objectSpread({}, (0, _reactUi.textEllipsis)("75%")),
          variant: "body2",
          children: name
        })]
      }) : null]
    }) : !error ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactUi.Loading, {
      size: 100
    }) : null
  });
};
var PreviewControls = function PreviewControls() {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
    justify: "between",
    css: {
      width: "100%",
      mt: "$8"
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactUi.Flex, {
      css: {
        gap: "$4"
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_AudioVideoToggle.AudioVideoToggle, {
        compact: true
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_VirtualBackground.VirtualBackground, {})]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(PreviewSettings, {})]
  });
};
var PreviewSettings = /*#__PURE__*/_react["default"].memo(function () {
  var _useState5 = (0, _react.useState)(false),
    _useState6 = _slicedToArray(_useState5, 2),
    open = _useState6[0],
    setOpen = _useState6[1];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconButton["default"], {
      "data-testid": "preview_setting_btn",
      onClick: function onClick() {
        return setOpen(function (value) {
          return !value;
        });
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactIcons.SettingsIcon, {})
    }), open && /*#__PURE__*/(0, _jsxRuntime.jsx)(_SettingsModal["default"], {
      open: open,
      onOpenChange: setOpen
    })]
  });
});
var _default = PreviewJoin;
exports["default"] = _default;